import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_COPIAR_DADOS } from 'store/modules/api/servico.actions'

const isSaving = loadingReducer(false, API_COPIAR_DADOS)

export default combineReducers({
  isSaving,
})
